import { DateInput, Filter, SearchInput } from "react-admin";

import React from "react";
import { ReferenceSelectInput } from "ra-friendsofbabba";

const Filters = (props) => {
  return (
    <Filter {...props}>
      <SearchInput source="q" alwaysOn fullWidth />
      <DateInput source="start" fullWidth />
      <DateInput source="end" fullWidth />
      <ReferenceSelectInput
        source="user_break_reason_id"
        reference="user-break-reasons"
        optionText="name"
        fullWidth
      />
    </Filter>
  );
};
export default Filters;
